// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__eM7sk","tag":"Tags_tag__796VC","click":"Tags_click__qY4hw","link":"Tags_link__r91PJ","blue":"Tags_blue__oYi8P"};